module.exports = __webpack_public_path__ + "static/media/Logo_Open_Galaxy.551d4fe8.png";